import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services/api';
import Paywall from '../pages/Paywall';
import { Loader2 } from 'lucide-react';

/**
 * Subscription gate - blocks access to protected routes for student accounts
 * that don't have an active paid subscription.
 * - Teachers, parents, admins, and is_demo accounts bypass the gate.
 */
const SubscriptionGate = ({ children }) => {
  const { user } = useAuth();
  const [checking, setChecking] = useState(true);
  const [active, setActive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      // Quick bypass for non-students or demo
      if (!user) { setChecking(false); return; }
      if (user.role !== 'student' || user.is_demo) {
        if (!cancelled) { setActive(true); setChecking(false); }
        return;
      }
      try {
        const r = await apiService.subscriptionStatus();
        if (!cancelled) {
          setActive(!!r.data.active);
          setChecking(false);
        }
      } catch (e) {
        if (!cancelled) { setChecking(false); }
      }
    };
    check();
    return () => { cancelled = true; };
  }, [user]);

  if (checking) {
    return (
      <div className="min-h-screen bg-[#F4F8FB] flex items-center justify-center">
        <Loader2 className="w-12 h-12 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (!active) {
    return <Paywall onActivated={() => setActive(true)} />;
  }

  return children;
};

export default SubscriptionGate;
